import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as accountActions } from '../../actions/accountActions';
import { actions as userActions } from '../../actions/userActions';
import { actions as supportActions } from '../../actions/supportActions';
import LoginStyleWrapper from '../Common/LoginStyleWrapper/LoginStyleWrapper';
import './login.scss';
import { WorkflowStepNames } from '../../constants/constants';
import IsEHAdminWorkflowStep from './WorkflowSteps/IsEHAdminWorkflowStep';
import PasswordExpiredWorkflowStep from './WorkflowSteps/PasswordExpiredWorkflowStep';
import ChooseSubscriptionWorkflowStep from './WorkflowSteps/ChooseSubscriptionWorkflowStep';
import InvalidDefaultLocationWorkflowStep from './WorkflowSteps/InvalidDefaultLocationWorkflowStep';
import SubscriptionDisclaimerWorkflowStep from './WorkflowSteps/SubscriptionDisclaimerWorkflowStep';
import SendToDestinationPage from './WorkflowSteps/SendToDestinationWorkflowStep';
import RequireMissingProfileInputWorkflowStep from './WorkflowSteps/RequireMissingProfileInputWorkflowStep';
import TfaSetupWorkflowStep from './WorkflowSteps/TfaSetupWorkflowStep';
import { Redirect } from 'react-router-dom';
import Routes from '../../constants/routes';
import Notification from '../Common/Notification';

export class LoginWorkflow extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    renderStep = (currentStep) => {
        switch (currentStep.name) {
            case WorkflowStepNames.PasswordExpired: {
                return <PasswordExpiredWorkflowStep user={this.props.user} step={currentStep} actions={this.props.accountActions} />
            }
            case WorkflowStepNames.IsEHAdmin: {
                return <IsEHAdminWorkflowStep user={this.props.user} step={currentStep} actions={this.props.accountActions} />
            }
            case WorkflowStepNames.ChooseSubscription: {
                return <ChooseSubscriptionWorkflowStep user={this.props.user} step={currentStep} actions={this.props.accountActions} />
            }
            case WorkflowStepNames.InvalidDefaultLocation: {
                return <InvalidDefaultLocationWorkflowStep user={this.props.user} step={currentStep} accountActions={this.props.accountActions} userActions={this.props.userActions} supportActions={this.props.supportActions} />
            }
            case WorkflowStepNames.SubscriptionDisclaimer: {
                return <SubscriptionDisclaimerWorkflowStep user={this.props.user} step={currentStep} accountActions={this.props.accountActions} userActions={this.props.userActions} />
            }
            case WorkflowStepNames.SendToDestinationPage: {
                return <SendToDestinationPage user={this.props.user} step={currentStep} actions={this.props.accountActions} />
            }
            case WorkflowStepNames.RequireMissingProfileInput: {
                return <RequireMissingProfileInputWorkflowStep step={currentStep} userActions={this.props.userActions} accountActions={this.props.accountActions} />
            }
            case WorkflowStepNames.ConfigureTfa: {
                return <TfaSetupWorkflowStep user={this.props.user} step={currentStep} />
            }
            // Future workflow steps go here
            default: {
                return <div className="alert alert-danger" role="alert">Unable to determine current workflow step</div>
            }
        }
    }

    render() {
        let workflow = this.props.user.loginWorkflow;
        if (!workflow) {
            Notification("error", "Error", "Post Login Workflow expected but not found");
            return (<Redirect to={Routes.LoginPage} />);
        }

        let currentStep = (workflow.steps && workflow.steps.length > 0) ? workflow.steps[0] : null;
        if (!currentStep) {
            Notification("error", "Error", "Post Login Workflow Current Step expected but not found");
            return (<Redirect to={Routes.LoginPage} />);
        }

        return (
            <LoginStyleWrapper>
                {this.renderStep(currentStep)}
            </LoginStyleWrapper>
        );
    }
}

LoginWorkflow.propTypes = {
    user: PropTypes.object.isRequired,
    accountActions: PropTypes.object.isRequired,
    userActions: PropTypes.object.isRequired,
    supportActions: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        accountActions: bindActionCreators({ ...accountActions }, dispatch),
        userActions: bindActionCreators({ ...userActions }, dispatch),
        supportActions: bindActionCreators({ ...supportActions }, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(LoginWorkflow);
